import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPilone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPilone"><Path d="M8.61207 3.83089C8.91264 2.74884 9.89785 2 11.0209 2H12.9805C14.1035 2 15.0887 2.74884 15.3893 3.83089L17.103 10H6.89844L8.61207 3.83089Z" fill="currentColor"/><Path d="M6.61849 11L5.78516 14H18.2119L17.3786 11H6.61849Z" fill="currentColor"/><Path d="M18.4911 15H5.50884L4.11996 20H2.5C2.22386 20 2 20.2239 2 20.5C2 20.7761 2.22386 21 2.5 21H21.5C21.7761 21 22 20.7761 22 20.5C22 20.2239 21.7761 20 21.5 20H19.88L18.4911 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPilone;
